import type { FaturamentoResultado, FaturamentoModo } from '@/lib/calculos/faturamento'
import type { PendingCalc } from '@/lib/pending-calc'

/**
 * Converte o resultado vivo da calc de faturamento para o shape persistido
 * (PendingCalc / POST /api/calculos), alinhado ao schema Zod atualizado.
 */
export function buildFaturamentoPendingCalc(opts: {
  modo: FaturamentoModo
  faturamentoMes: number
  meses: { mes?: string; valor: number }[]
  resultado: FaturamentoResultado
}): PendingCalc {
  const { modo, faturamentoMes, meses, resultado } = opts

  const statusMap = {
    tranquilo: 'SEGURO',
    atencao: 'ATENCAO',
    estourou: 'EXCEDIDO',
  } as const

  return {
    tipo: 'FATURAMENTO',
    titulo:
      modo === 'projecao'
        ? `Projeção anual · ${resultado.percentUsado.toFixed(0)}% do teto`
        : `Controle do ano · ${resultado.percentUsado.toFixed(0)}% do teto`,
    inputs: {
      modo,
      faturamentoMes: modo === 'projecao' ? faturamentoMes : undefined,
      meses: modo === 'controle' ? meses : undefined,
    },
    resultado: {
      modo: resultado.modo,
      valorAno: resultado.valorAno,
      percentUsado: resultado.percentUsado,
      restanteAno: resultado.restanteAno,
      limiteAno: resultado.limiteAno,
      mediaMensal: resultado.mediaMensal,
      projecaoFim: resultado.projecaoFim,
      mesesPreenchidos: resultado.mesesPreenchidos,
      status: statusMap[resultado.status],
      // campos legados mantidos p/ leituras antigas no admin/histórico
      faturamentoAnual: resultado.valorAno,
      percentualUsado: resultado.percentUsado,
      tetoMEI: resultado.limiteAno,
      faltante: Math.max(0, resultado.restanteAno),
      mediaMonsal: resultado.mediaMensal ?? faturamentoMes,
      mensagemStatus:
        resultado.status === 'estourou'
          ? 'Projeção acima do teto do MEI'
          : resultado.status === 'atencao'
            ? 'Perto do teto — acompanhe de perto'
            : 'Dentro do teto',
      mesesProblematicos: [],
    },
  }
}
